import clsx from "clsx";

export const CancelIcon = (
  <svg
    width={26}
    height={26}
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="flex-grow-0 flex-shrink-0 w-[26px] h-[26px]"
    preserveAspectRatio="none">
    {/* <circle cx={13} cy={13} r={12} stroke="#191919" strokeWidth={2} /> */}
    <path d="M17.3555 8.67578L8.67377 17.3575" stroke="#191919" strokeWidth={2} />
    <path d="M17.3555 17.3574L8.67377 8.67572" stroke="#191919" strokeWidth={2} />
  </svg>
);
export const ThreeDotsIcon = ({ isSelected }) => (
  <svg
    className={clsx("text-black group-hover:text-white", { "text-white": isSelected })}
    width={45}
    height={5}
    viewBox="0 0 45 5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <circle cx={27} cy="2.5" r={2} fill="currentColor" />
    <circle cx={35} cy="2.5" r={2} fill="currentColor" />
    <circle cx={43} cy="2.5" r={2} fill="currentColor" />
  </svg>
);

export const ArrowLeftIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.1668 8.50002C14.1668 7.11719 14.0528 5.84247 13.9177 4.81931C13.796 3.89849 13.1017 3.20414 12.1809 3.08253C11.1577 2.9474 9.88299 2.83335 8.50016 2.83335C7.11733 2.83335 5.84261 2.9474 4.81946 3.08253C3.89863 3.20414 3.20428 3.89849 3.08267 4.81931C2.94754 5.84247 2.8335 7.11719 2.8335 8.50002C2.8335 9.88285 2.94754 11.1576 3.08267 12.1807C3.20428 13.1015 3.89863 13.7959 4.81945 13.9175C5.84261 14.0526 7.11733 14.1667 8.50016 14.1667C9.88299 14.1667 11.1577 14.0526 12.1809 13.9175C13.1017 13.7959 13.796 13.1015 13.9177 12.1807C14.0528 11.1576 14.1668 9.88285 14.1668 8.50002ZM15.3221 4.63382C15.1166 3.07776 13.9224 1.88357 12.3664 1.67806C11.2966 1.53677 9.95843 1.41669 8.50016 1.41669C7.0419 1.41669 5.70372 1.53677 4.63397 1.67806C3.0779 1.88357 1.88371 3.07776 1.6782 4.63382C1.53692 5.70358 1.41683 7.04176 1.41683 8.50002C1.41683 9.95828 1.53692 11.2965 1.6782 12.3662C1.88371 13.9223 3.0779 15.1165 4.63396 15.322C5.70372 15.4633 7.0419 15.5834 8.50016 15.5834C9.95843 15.5834 11.2966 15.4633 12.3664 15.322C13.9224 15.1165 15.1166 13.9223 15.3221 12.3662C15.4634 11.2965 15.5835 9.95828 15.5835 8.50002C15.5835 7.04176 15.4634 5.70358 15.3221 4.63382Z"
      fill="#606060"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.48 10.0634C11.2034 10.34 10.7549 10.34 10.4783 10.0634L8.5 8.08507L6.5217 10.0634C6.24508 10.34 5.79659 10.34 5.51997 10.0634C5.24334 9.78675 5.24334 9.33825 5.51997 9.06163L7.99913 6.58247C8.27575 6.30584 8.72425 6.30584 9.00087 6.58247L11.48 9.06163C11.7567 9.33825 11.7567 9.78675 11.48 10.0634Z"
      fill="#606060"
    />
  </svg>
);

export const MinusSquare = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.50016 3.16659C7.95465 3.16659 6.52996 3.29405 5.38643 3.44507C4.35728 3.58099 3.58124 4.35703 3.44532 5.38619C3.29429 6.52971 3.16683 7.9544 3.16683 9.49992C3.16683 11.0454 3.29429 12.4701 3.44532 13.6137C3.58124 14.6428 4.35728 15.4188 5.38643 15.5548C6.52996 15.7058 7.95465 15.8333 9.50016 15.8333C11.0457 15.8333 12.4704 15.7058 13.6139 15.5548C14.643 15.4188 15.4191 14.6428 15.555 13.6137C15.706 12.4701 15.8335 11.0454 15.8335 9.49992C15.8335 7.9544 15.706 6.52971 15.555 5.38619C15.4191 4.35703 14.643 3.58099 13.6139 3.44507C12.4704 3.29405 11.0457 3.16659 9.50016 3.16659ZM5.17912 1.87537C3.43999 2.10506 2.1053 3.43974 1.87562 5.17887C1.71771 6.37448 1.5835 7.87009 1.5835 9.49992C1.5835 11.1297 1.71771 12.6254 1.87562 13.821C2.1053 15.5601 3.43999 16.8948 5.17912 17.1245C6.37473 17.2824 7.87034 17.4166 9.50016 17.4166C11.13 17.4166 12.6256 17.2824 13.8212 17.1245C15.5603 16.8948 16.895 15.5601 17.1247 13.821C17.2826 12.6254 17.4168 11.1297 17.4168 9.49992C17.4168 7.87009 17.2826 6.37448 17.1247 5.17887C16.895 3.43974 15.5603 2.10506 13.8212 1.87537C12.6256 1.71747 11.13 1.58325 9.50016 1.58325C7.87034 1.58325 6.37473 1.71747 5.17912 1.87537Z"
      fill="#606060"
    />
    <path
      d="M6.33317 10.2916C5.89594 10.2916 5.5415 9.93714 5.5415 9.49992C5.5415 9.06269 5.89595 8.70825 6.33317 8.70825H12.6665C13.1037 8.70825 13.4582 9.06269 13.4582 9.49992C13.4582 9.93714 13.1037 10.2916 12.6665 10.2916H6.33317Z"
      fill="#606060"
    />
  </svg>
);
export const TerniaryBackIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.34299 11.9932C4.8749 7.96575 7.96575 4.8749 11.9932 4.34299C14.762 3.97732 18.2255 3.6665 21.9998 3.6665C25.7742 3.6665 29.2377 3.97732 32.0065 4.34299C36.0339 4.8749 39.1248 7.96575 39.6567 11.9932C40.0224 14.762 40.3332 18.2255 40.3332 21.9998C40.3332 25.7742 40.0224 29.2377 39.6567 32.0065C39.1248 36.0339 36.0339 39.1248 32.0065 39.6567C29.2377 40.0224 25.7742 40.3332 21.9998 40.3332C18.2255 40.3332 14.762 40.0224 11.9932 39.6567C7.96575 39.1248 4.8749 36.0339 4.34299 32.0065C3.97732 29.2377 3.6665 25.7742 3.6665 21.9998C3.6665 18.2255 3.97732 14.762 4.34299 11.9932ZM26.0462 16.8795C26.7622 16.1636 26.7622 15.0028 26.0462 14.2868C25.3302 13.5708 24.1694 13.5708 23.4535 14.2868L17.0368 20.7035C16.3208 21.4194 16.3208 22.5802 17.0368 23.2962L23.4535 29.7129C24.1694 30.4288 25.3302 30.4288 26.0462 29.7129C26.7622 28.9969 26.7622 27.8361 26.0462 27.1201L20.9259 21.9998L26.0462 16.8795Z"
      fill="#606060"
    />
  </svg>
);
export const ToggleBack = () => (
  <svg
    fill="#000000"
    height="32"
    width="32"
    version="1.1"
    id="Icons"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32">
    <path
      d="M23,8H9c-4.4,0-8,3.6-8,8s3.6,8,8,8h14c4.4,0,8-3.6,8-8S27.4,8,23,8z M9,21c-2.8,0-5-2.2-5-5s2.2-5,5-5s5,2.2,5,5
	S11.8,21,9,21z"
    />
  </svg>
);
export const PluseSquare = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 4C10.0478 4 8.24816 4.161 6.80371 4.35177C5.50372 4.52346 4.52346 5.50372 4.35177 6.80371C4.16101 8.24816 4 10.0478 4 12C4 13.9522 4.161 15.7518 4.35177 17.1963C4.52346 18.4963 5.50372 19.4765 6.80371 19.6482C8.24816 19.839 10.0478 20 12 20C13.9522 20 15.7518 19.839 17.1963 19.6482C18.4963 19.4765 19.4765 18.4963 19.6482 17.1963C19.839 15.7518 20 13.9522 20 12C20 10.0478 19.839 8.24816 19.6482 6.80371C19.4765 5.50372 18.4963 4.52346 17.1963 4.35177C15.7518 4.16101 13.9522 4 12 4ZM6.54184 2.36899C4.34504 2.65912 2.65912 4.34504 2.36899 6.54184C2.16953 8.05208 2 9.94127 2 12C2 14.0587 2.16953 15.9479 2.36899 17.4582C2.65912 19.655 4.34504 21.3409 6.54184 21.631C8.05208 21.8305 9.94127 22 12 22C14.0587 22 15.9479 21.8305 17.4582 21.631C19.655 21.3409 21.3409 19.655 21.631 17.4582C21.8305 15.9479 22 14.0587 22 12C22 9.94127 21.8305 8.05208 21.631 6.54184C21.3409 4.34504 19.655 2.65912 17.4582 2.36899C15.9479 2.16953 14.0587 2 12 2C9.94127 2 8.05208 2.16953 6.54184 2.36899Z"
      fill="#515151"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 17C12.5523 17 13 16.5523 13 16V13H16C16.5523 13 17 12.5523 17 12C17 11.4477 16.5523 11 16 11H13V8C13 7.44772 12.5523 7 12 7C11.4477 7 11 7.44772 11 8V11H8C7.44772 11 7 11.4477 7 12C7 12.5523 7.44771 13 8 13H11V16C11 16.5523 11.4477 17 12 17Z"
      fill="#515151"
    />
  </svg>
);
export const CancelIconWhite = (
  <svg
    width={26}
    height={26}
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="flex-grow-0 flex-shrink-0 w-[26px] h-[26px]"
    preserveAspectRatio="none">
    {/* <circle cx={13} cy={13} r={12} stroke="#191919" strokeWidth={2} /> */}
    <path d="M17.3555 8.67578L8.67377 17.3575" stroke="#ffffff" strokeWidth={2} />
    <path d="M17.3555 17.3574L8.67377 8.67572" stroke="#ffffff" strokeWidth={2} />
  </svg>
);

export const MultiUserCogIcon = ({ isSelected = false }) => {
  return (
    <>
      <svg
        className={clsx("text-black group-hover:text-white", { "text-white": isSelected })}
        width="30"
        height="31"
        viewBox="0 0 30 31"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_4411_50592)">
          <path
            d="M7.5 5.1875C4.40625 5.1875 1.875 7.71875 1.875 10.8125C1.875 12.6875 2.8125 14.3757 4.21875 15.3132C1.6875 16.6257 0 19.1563 0 22.0625H1.875C1.875 18.9688 4.40625 16.4375 7.5 16.4375C10.5937 16.4375 13.125 18.9688 13.125 22.0625H15C15 19.0625 17.4382 16.5313 20.4382 16.4375H20.625C22.9688 16.4375 24.9375 15.0316 25.7812 13.0629C25.7812 13.0629 25.7809 12.9695 25.8746 12.9695C25.9684 12.8757 25.968 12.6879 25.968 12.5941C25.968 12.5004 25.9695 12.4993 26.0632 12.4055C26.0632 12.3118 26.1566 12.1257 26.1566 12.032C26.1566 11.9382 26.1562 11.8438 26.25 11.75C26.25 11.6562 26.2496 11.5618 26.3434 11.468V10.9993V10.9059C26.3434 7.81213 23.8121 5.28088 20.7184 5.28088C17.6246 5.28088 15.0934 7.81213 15.0934 10.9059C15.0934 12.7809 16.0309 14.4691 17.4371 15.4066C16.0309 16.0629 14.9059 17.1868 14.1559 18.4993C13.4059 17.1868 12.2809 16.0629 10.8746 15.4066C12.1871 14.3754 13.125 12.6875 13.125 10.8125C13.125 7.71875 10.5937 5.1875 7.5 5.1875ZM7.5 7.0625C9.5625 7.0625 11.25 8.75 11.25 10.8125C11.25 12.875 9.5625 14.5625 7.5 14.5625C5.4375 14.5625 3.75 12.875 3.75 10.8125C3.75 8.75 5.4375 7.0625 7.5 7.0625ZM20.625 7.0625C22.6875 7.0625 24.375 8.75 24.375 10.8125C24.375 12.875 22.6875 14.5625 20.625 14.5625C18.5625 14.5625 16.875 12.875 16.875 10.8125C16.875 8.75 18.5625 7.0625 20.625 7.0625ZM22.5934 17.375V19.3434C22.0309 19.4371 21.4691 19.7195 21.0004 20.0007L19.5941 18.5945L18.2812 19.9055L19.6875 21.3118C19.3125 21.7805 19.1257 22.3438 19.032 23H16.875V24.875H18.8434C18.9371 25.4375 19.2195 26.0007 19.5007 26.5632L18.0945 27.9695L19.4055 29.2805L20.8118 27.8743C21.2805 28.1555 21.8441 28.4379 22.4066 28.5316V30.5H24.2816V28.5316C24.8441 28.4379 25.4059 28.1555 25.8746 27.8743L27.2809 29.2805L28.5938 27.9695L27.1875 26.5632C27.5625 26.0945 27.7493 25.5312 27.843 24.875H30V23H28.0316C27.9379 22.4375 27.6555 21.8743 27.3743 21.3118L28.7805 19.9055L27.4695 18.5945L26.0632 20.0007C25.5945 19.7195 25.0309 19.4371 24.4684 19.3434V17.375H22.5934ZM23.4375 21.125C25.0313 21.125 26.25 22.3437 26.25 23.9375C26.25 25.5313 25.0313 26.75 23.4375 26.75C21.8437 26.75 20.625 25.5313 20.625 23.9375C20.625 22.3437 21.8437 21.125 23.4375 21.125ZM23.4375 23C23.3203 23 23.2031 23.0293 23.0933 23.0806C22.9834 23.1318 22.8809 23.2051 22.793 23.293C22.7051 23.3809 22.6318 23.4834 22.5806 23.5933C22.5293 23.7031 22.5 23.8203 22.5 23.9375C22.5 24.0547 22.5293 24.1719 22.5806 24.2817C22.6318 24.3916 22.7051 24.4941 22.793 24.582C22.8809 24.6699 22.9834 24.7432 23.0933 24.7944C23.2031 24.8457 23.3203 24.875 23.4375 24.875C23.9062 24.875 24.375 24.4062 24.375 23.9375C24.375 23.4688 23.9062 23 23.4375 23Z"
            fill="currentColor"
          />
        </g>
        <defs>
          <clipPath id="clip0_4411_50592">
            <rect width="30" height="30" fill="currentColor" transform="translate(0 0.5)" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};

export const MenuIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="icon icon-tabler icon-tabler-menu-2"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    strokeWidth="1.5"
    stroke="#ffffff"
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round">
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <line x1={4} y1={6} x2={20} y2={6} />
    <line x1={4} y1={12} x2={20} y2={12} />
    <line x1={4} y1={18} x2={20} y2={18} />
  </svg>
);

export const InfoIcon = () => {
  return (
    <svg width={20} height={19} viewBox="0 0 58 58" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M28.9997 53.1663C42.3466 53.1663 53.1663 42.3466 53.1663 28.9997C53.1663 15.6528 42.3466 4.83301 28.9997 4.83301C15.6528 4.83301 4.83301 15.6528 4.83301 28.9997C4.83301 42.3466 15.6528 53.1663 28.9997 53.1663Z"
        stroke="currentColor"
        strokeOpacity="0.4"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29 38.6667V29"
        stroke="currentColor"
        strokeOpacity="0.4"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29 19.333H29.0242"
        stroke="currentColor"
        strokeOpacity="0.4"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const TickIcon = (
  <svg
    width={20}
    height={19}
    viewBox="0 0 20 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="flex-grow-0 flex-shrink-0 w-[19px] h-[19px] mt-0.5"
    preserveAspectRatio="none">
    <circle cx={10} cy="9.5" r="9.5" fill="#163F9B" />
    <path d="M4.93359 9.50065L8.73359 13.3007L15.7003 6.33398" stroke="white" strokeWidth={2} />
  </svg>
);

export const RefreshIcon = ({ color }) => {
  return (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 0.71875C5.50403 0.71875 0.21875 6.00403 0.21875 12.5C0.21875 18.996 5.50403 24.2812 12 24.2812C18.496 24.2812 23.7812 18.996 23.7812 12.5H21.9688C21.9688 18.0154 17.5154 22.4688 12 22.4688C6.48462 22.4688 2.03125 18.0154 2.03125 12.5C2.03125 6.98462 6.48462 2.53125 12 2.53125C15.5117 2.53125 18.5809 4.32959 20.3545 7.0625H15.625V8.875H22.875V1.625H21.0625V4.99512C18.9031 2.38965 15.6427 0.71875 12 0.71875Z"
        fill={color}
      />
    </svg>
  );
};

export const BackIcon = ({ onClickHandler }) => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="cursor-pointer mr-[5rem]"
      onClick={onClickHandler}>
      <path
        d="M1.55023e-07 13C6.95463e-08 20.168 5.83203 26 13 26C20.168 26 26 20.168 26 13C26 5.83203 20.168 2.40501e-07 13 1.55023e-07C5.83203 6.95463e-08 2.40501e-07 5.83203 1.55023e-07 13ZM2 13C2 6.91406 6.91406 2 13 2C19.0859 2 24 6.91406 24 13C24 19.0859 19.0859 24 13 24C6.91406 24 2 19.0859 2 13ZM6 13L10 17L10 14L20 14L20 12L10 12L10 9L6 13Z"
        fill="#191919"
      />
    </svg>
  );
};

export const orangeTickIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17" viewBox="0 0 18 17" fill="none">
    <circle cx="9" cy="8.5" r="8.5" fill="#FC9E5A" />
    <path d="M5.67383 8.50004L7.89122 11.087L12.326 5.91309" stroke="white" />
  </svg>
);

export const grayTickIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17" viewBox="0 0 18 17" fill="none">
    <circle cx="9" cy="8.5" r="8.5" fill="#d6d6d6" />
    <path d="M5.67383 8.50004L7.89122 11.087L12.326 5.91309" stroke="white" />
  </svg>
);

export const editIcon = (
  <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.7188 0.015625C10.3599 0.015625 10.0083 0.164062 9.7373 0.453125L5.09375 5.39062L4.99121 5.5L4.96191 5.65625L4.63965 7.40625L4.49316 8.14062L5.18164 7.98438L6.82227 7.64062L6.96875 7.60938L7.07129 7.5L11.7002 2.54688C12.2404 1.9707 12.2404 1.0293 11.7002 0.453125C11.4292 0.164062 11.0776 0.015625 10.7188 0.015625ZM10.7188 0.984375C10.8286 0.984375 10.9366 1.04492 11.041 1.15625C11.2498 1.37891 11.2498 1.62109 11.041 1.84375L6.5 6.6875L5.69434 6.85938L5.85547 6L10.3965 1.15625C10.5009 1.04492 10.6089 0.984375 10.7188 0.984375ZM0.875 2V12H10.25V5.40625L9.3125 6.40625V11H1.8125V3H6.11914L7.05664 2H0.875Z"
      fill="#191919"
    />
  </svg>
);

export const editIconPencil = (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M3 22C3 21.4477 3.44772 21 4 21H20C20.5523 21 21 21.4477 21 22C21 22.5523 20.5523 23 20 23H4C3.44772 23 3 22.5523 3 22Z"
      fill="#515151"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.7071 3.12126C16.3166 2.73074 15.6834 2.73074 15.2929 3.12126L14.4142 3.99991L18 7.5857L18.8787 6.70705C19.2692 6.31652 19.2692 5.68336 18.8787 5.29284L16.7071 3.12126ZM6.91425 11.4999L13 5.41412L16.5858 8.99991L10.5 15.0857L6.91425 11.4999ZM5.50003 12.9141L5 13.4142V16.9999H8.58579L9.08582 16.4999L5.50003 12.9141ZM13.8787 1.70705C15.0503 0.535476 16.9497 0.535476 18.1213 1.70705L20.2929 3.87862C21.4645 5.0502 21.4645 6.94969 20.2929 8.12126L10 18.4142C9.62493 18.7892 9.11622 18.9999 8.58579 18.9999H5C3.89543 18.9999 3 18.1045 3 16.9999V13.4142C3 12.8837 3.21071 12.375 3.58579 11.9999L13.8787 1.70705Z"
      fill="#515151"
    />
  </svg>
);

export const VerticalIcon = () => (
  <svg
    width="30px"
    height="30px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9 6H9.01M15 6H15.01M15 12H15.01M9 12H9.01M9 18H9.01M15 18H15.01M10 6C10 6.55228 9.55228 7 9 7C8.44772 7 8 6.55228 8 6C8 5.44772 8.44772 5 9 5C9.55228 5 10 5.44772 10 6ZM16 6C16 6.55228 15.5523 7 15 7C14.4477 7 14 6.55228 14 6C14 5.44772 14.4477 5 15 5C15.5523 5 16 5.44772 16 6ZM10 12C10 12.5523 9.55228 13 9 13C8.44772 13 8 12.5523 8 12C8 11.4477 8.44772 11 9 11C9.55228 11 10 11.4477 10 12ZM16 12C16 12.5523 15.5523 13 15 13C14.4477 13 14 12.5523 14 12C14 11.4477 14.4477 11 15 11C15.5523 11 16 11.4477 16 12ZM10 18C10 18.5523 9.55228 19 9 19C8.44772 19 8 18.5523 8 18C8 17.4477 8.44772 17 9 17C9.55228 17 10 17.4477 10 18ZM16 18C16 18.5523 15.5523 19 15 19C14.4477 19 14 18.5523 14 18C14 17.4477 14.4477 17 15 17C15.5523 17 16 17.4477 16 18Z"
      stroke="#000000"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const VectorThreeDotIcon = () => (
  <svg width="14" height="23" viewBox="0 0 14 23" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.5 5.5C4.05228 5.5 4.5 5.05228 4.5 4.5C4.5 3.94772 4.05228 3.5 3.5 3.5C2.94772 3.5 2.5 3.94772 2.5 4.5C2.5 5.05228 2.94772 5.5 3.5 5.5Z"
      stroke="#606060"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.5 5.5C11.0523 5.5 11.5 5.05228 11.5 4.5C11.5 3.94772 11.0523 3.5 10.5 3.5C9.94772 3.5 9.5 3.94772 9.5 4.5C9.5 5.05228 9.94772 5.5 10.5 5.5Z"
      stroke="#606060"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.5 12.5C4.05228 12.5 4.5 12.0523 4.5 11.5C4.5 10.9477 4.05228 10.5 3.5 10.5C2.94772 10.5 2.5 10.9477 2.5 11.5C2.5 12.0523 2.94772 12.5 3.5 12.5Z"
      stroke="#606060"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.5 12.5C11.0523 12.5 11.5 12.0523 11.5 11.5C11.5 10.9477 11.0523 10.5 10.5 10.5C9.94772 10.5 9.5 10.9477 9.5 11.5C9.5 12.0523 9.94772 12.5 10.5 12.5Z"
      stroke="#606060"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.5 19.5C4.05228 19.5 4.5 19.0523 4.5 18.5C4.5 17.9477 4.05228 17.5 3.5 17.5C2.94772 17.5 2.5 17.9477 2.5 18.5C2.5 19.0523 2.94772 19.5 3.5 19.5Z"
      stroke="#606060"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.5 19.5C11.0523 19.5 11.5 19.0523 11.5 18.5C11.5 17.9477 11.0523 17.5 10.5 17.5C9.94772 17.5 9.5 17.9477 9.5 18.5C9.5 19.0523 9.94772 19.5 10.5 19.5Z"
      stroke="#606060"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const SearchIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
    <path
      d="M9.4375 2.5625C13.2268 2.5625 16.3125 5.64819 16.3125 9.4375C16.3125 11.0837 15.7351 12.593 14.7656 13.7773L20.2441 19.2559L19.2559 20.2441L13.7773 14.7656C12.593 15.7351 11.0837 16.3125 9.4375 16.3125C5.64819 16.3125 2.5625 13.2268 2.5625 9.4375C2.5625 5.64819 5.64819 2.5625 9.4375 2.5625ZM9.4375 3.9375C6.39209 3.9375 3.9375 6.39209 3.9375 9.4375C3.9375 12.4829 6.39209 14.9375 9.4375 14.9375C12.4829 14.9375 14.9375 12.4829 14.9375 9.4375C14.9375 6.39209 12.4829 3.9375 9.4375 3.9375Z"
      fill="#515151"
    />
  </svg>
);
export const RemoveIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.04184 2.86899C4.84504 3.15912 3.15912 4.84504 2.86899 7.04184C2.66953 8.55208 2.5 10.4413 2.5 12.5C2.5 14.5587 2.66953 16.4479 2.86899 17.9582C3.15912 20.155 4.84504 21.8409 7.04184 22.131C8.55208 22.3305 10.4413 22.5 12.5 22.5C14.5587 22.5 16.4479 22.3305 17.9582 22.131C20.155 21.8409 21.8409 20.155 22.131 17.9582C22.3305 16.4479 22.5 14.5587 22.5 12.5C22.5 10.4413 22.3305 8.55208 22.131 7.04184C21.8409 4.84504 20.155 3.15912 17.9582 2.86899C16.4479 2.66953 14.5587 2.5 12.5 2.5C10.4413 2.5 8.55208 2.66953 7.04184 2.86899ZM7.5 12.5C7.5 13.0523 7.94771 13.5 8.5 13.5H16.5C17.0523 13.5 17.5 13.0523 17.5 12.5C17.5 11.9477 17.0523 11.5 16.5 11.5H8.5C7.94772 11.5 7.5 11.9477 7.5 12.5Z"
      fill="#515151"
    />
  </svg>
);
export const DropDownIcon = () => (
  <svg width="9" height="13" viewBox="0 0 9 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.5 0.5L7.9641 5L1.0359 5L4.5 0.5Z" fill="#515151" />
    <path d="M4.5 12.5L1.0359 8L7.9641 8L4.5 12.5Z" fill="#515151" />
  </svg>
);
export const ArrowBackIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 44 44" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.34299 11.9934C4.8749 7.9659 7.96575 4.87505 11.9932 4.34314C14.762 3.97747 18.2255 3.66666 21.9998 3.66666C25.7742 3.66666 29.2377 3.97747 32.0065 4.34314C36.0339 4.87505 39.1248 7.9659 39.6567 11.9934C40.0224 14.7621 40.3332 18.2257 40.3332 22C40.3332 25.7743 40.0224 29.2378 39.6567 32.0066C39.1248 36.0341 36.0339 39.1249 32.0065 39.6568C29.2377 40.0225 25.7742 40.3333 21.9998 40.3333C18.2255 40.3333 14.762 40.0225 11.9932 39.6568C7.96575 39.1249 4.8749 36.0341 4.34299 32.0066C3.97732 29.2378 3.6665 25.7743 3.6665 22C3.6665 18.2257 3.97732 14.7621 4.34299 11.9934ZM26.0462 16.8797C26.7622 16.1637 26.7622 15.0029 26.0462 14.287C25.3302 13.571 24.1694 13.571 23.4535 14.287L17.0368 20.7036C16.3208 21.4196 16.3208 22.5804 17.0368 23.2964L23.4535 29.713C24.1694 30.429 25.3302 30.429 26.0462 29.713C26.7622 28.9971 26.7622 27.8363 26.0462 27.1203L20.9259 22L26.0462 16.8797Z"
      fill="#606060"
    />
  </svg>
);
export const PlusIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.72411 2.07287C3.80191 2.32673 2.32673 3.80191 2.07287 5.72411C1.89834 7.04557 1.75 8.69862 1.75 10.5C1.75 12.3014 1.89834 13.9544 2.07287 15.2759C2.32673 17.1981 3.80191 18.6733 5.72411 18.9271C7.04557 19.1017 8.69862 19.25 10.5 19.25C12.3014 19.25 13.9544 19.1017 15.2759 18.9271C17.1981 18.6733 18.6733 17.1981 18.9271 15.2759C19.1017 13.9544 19.25 12.3014 19.25 10.5C19.25 8.69862 19.1017 7.04557 18.9271 5.72411C18.6733 3.80191 17.1981 2.32673 15.2759 2.07287C13.9544 1.89834 12.3014 1.75 10.5 1.75C8.69862 1.75 7.04557 1.89834 5.72411 2.07287ZM10.5 6.125C10.0168 6.125 9.625 6.51675 9.625 7V9.625H7C6.51675 9.625 6.125 10.0168 6.125 10.5C6.125 10.9832 6.51675 11.375 7 11.375H9.625V14C9.625 14.4832 10.0168 14.875 10.5 14.875C10.9832 14.875 11.375 14.4832 11.375 14V11.375H14C14.4832 11.375 14.875 10.9832 14.875 10.5C14.875 10.0168 14.4832 9.625 14 9.625H11.375V7C11.375 6.51675 10.9832 6.125 10.5 6.125Z"
        fill="#606060"
      />
    </svg>
  );
};

export const InfoBlackIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.5 20C16.9183 20 20.5 16.4183 20.5 12C20.5 7.58172 16.9183 4 12.5 4C8.08172 4 4.5 7.58172 4.5 12C4.5 16.4183 8.08172 20 12.5 20ZM12.5 22C18.0228 22 22.5 17.5228 22.5 12C22.5 6.47715 18.0228 2 12.5 2C6.97715 2 2.5 6.47715 2.5 12C2.5 17.5228 6.97715 22 12.5 22Z"
      fill="#12131A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.5 7C11.9477 7 11.5 7.44772 11.5 8C11.5 8.55229 11.9477 9 12.5 9C13.0523 9 13.5 8.55229 13.5 8C13.5 7.44772 13.0523 7 12.5 7ZM12.5 11C11.9477 11 11.5 11.4477 11.5 12V16C11.5 16.5523 11.9477 17 12.5 17C13.0523 17 13.5 16.5523 13.5 16V12C13.5 11.4477 13.0523 11 12.5 11Z"
      fill="#12131A"
    />
  </svg>
);

export const CheckedBoxIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="27" height="26" viewBox="0 0 27 26" fill="none">
    <circle cx="13.5" cy="13" r="13" fill="#7C7D82" />
    <path
      d="M7.92859 13.1955L10.8094 16.0258C11.1984 16.408 11.822 16.408 12.211 16.0257L19.0714 9.28571"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const UncheckedBoxIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="27" height="26" viewBox="0 0 27 26" fill="none">
    <circle cx="13.5" cy="13" r="13" fill="#dcdcdc" />
  </svg>
);

export const CalendarIcon = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19 6.5H5C4.44772 6.5 4 6.94772 4 7.5V19.5C4 20.0523 4.44772 20.5 5 20.5H19C19.5523 20.5 20 20.0523 20 19.5V7.5C20 6.94771 19.5523 6.5 19 6.5ZM5 4.5C3.34315 4.5 2 5.84315 2 7.5V19.5C2 21.1569 3.34315 22.5 5 22.5H19C20.6569 22.5 22 21.1569 22 19.5V7.5C22 5.84315 20.6569 4.5 19 4.5H5Z"
      fill="#515151"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 12.5C9.44772 12.5 9 12.9477 9 13.5C9 14.0523 9.44772 14.5 10 14.5H17C17.5523 14.5 18 14.0523 18 13.5C18 12.9477 17.5523 12.5 17 12.5H10ZM7 16.5C6.44772 16.5 6 16.9477 6 17.5C6 18.0523 6.44772 18.5 7 18.5H13C13.5523 18.5 14 18.0523 14 17.5C14 16.9477 13.5523 16.5 13 16.5H7Z"
      fill="#515151"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 2.5C6.44772 2.5 6 2.94772 6 3.5V7.5C6 8.05228 6.44772 8.5 7 8.5C7.55228 8.5 8 8.05228 8 7.5V3.5C8 2.94772 7.55228 2.5 7 2.5ZM17 2.5C16.4477 2.5 16 2.94772 16 3.5V7.5C16 8.05228 16.4477 8.5 17 8.5C17.5523 8.5 18 8.05228 18 7.5V3.5C18 2.94772 17.5523 2.5 17 2.5Z"
      fill="#515151"
    />
  </svg>
);
export const EditIcon = ({ className }) => (
  <svg
    className={clsx("cursor-pointer", className)}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3 22C3 21.4477 3.44772 21 4 21H20C20.5523 21 21 21.4477 21 22C21 22.5523 20.5523 23 20 23H4C3.44772 23 3 22.5523 3 22Z"
      fill="#515151"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.7071 3.12102C16.3166 2.73049 15.6834 2.73049 15.2929 3.12102L14.4142 3.99967L18 7.58545L18.8787 6.7068C19.2692 6.31628 19.2692 5.68312 18.8787 5.29259L16.7071 3.12102ZM6.91425 11.4997L13 5.41388L16.5858 8.99967L10.5 15.0855L6.91425 11.4997ZM5.50003 12.9139L5 13.4139V16.9997H8.58579L9.08582 16.4997L5.50003 12.9139ZM13.8787 1.7068C15.0503 0.535232 16.9497 0.535232 18.1213 1.7068L20.2929 3.87838C21.4645 5.04995 21.4645 6.94945 20.2929 8.12102L10 18.4139C9.62493 18.789 9.11622 18.9997 8.58579 18.9997H5C3.89543 18.9997 3 18.1043 3 16.9997V13.4139C3 12.8835 3.21071 12.3748 3.58579 11.9997L13.8787 1.7068Z"
      fill="#515151"
    />
  </svg>
);

export const SortIcon = () => {
  return (
    <svg width="14" height="23" viewBox="0 0 14 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.5 5.5C4.05228 5.5 4.5 5.05228 4.5 4.5C4.5 3.94772 4.05228 3.5 3.5 3.5C2.94772 3.5 2.5 3.94772 2.5 4.5C2.5 5.05228 2.94772 5.5 3.5 5.5Z"
        stroke="#606060"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5 5.5C11.0523 5.5 11.5 5.05228 11.5 4.5C11.5 3.94772 11.0523 3.5 10.5 3.5C9.94772 3.5 9.5 3.94772 9.5 4.5C9.5 5.05228 9.94772 5.5 10.5 5.5Z"
        stroke="#606060"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.5 12.5C4.05228 12.5 4.5 12.0523 4.5 11.5C4.5 10.9477 4.05228 10.5 3.5 10.5C2.94772 10.5 2.5 10.9477 2.5 11.5C2.5 12.0523 2.94772 12.5 3.5 12.5Z"
        stroke="#606060"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5 12.5C11.0523 12.5 11.5 12.0523 11.5 11.5C11.5 10.9477 11.0523 10.5 10.5 10.5C9.94772 10.5 9.5 10.9477 9.5 11.5C9.5 12.0523 9.94772 12.5 10.5 12.5Z"
        stroke="#606060"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.5 19.5C4.05228 19.5 4.5 19.0523 4.5 18.5C4.5 17.9477 4.05228 17.5 3.5 17.5C2.94772 17.5 2.5 17.9477 2.5 18.5C2.5 19.0523 2.94772 19.5 3.5 19.5Z"
        stroke="#606060"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5 19.5C11.0523 19.5 11.5 19.0523 11.5 18.5C11.5 17.9477 11.0523 17.5 10.5 17.5C9.94772 17.5 9.5 17.9477 9.5 18.5C9.5 19.0523 9.94772 19.5 10.5 19.5Z"
        stroke="#606060"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
